module.exports = __webpack_public_path__ + "static/media/PricingNote_IPOIntelligence.3a4eccd8.png";